"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _findIndex = _interopRequireDefault(require("./findIndex"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    if (i % 2) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(arguments[i]));
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var DEFAULT_INITIAL_PERMISSIONS = ['ARCHIVE', 'UPDATE', 'READ'];

var shouldIncludeAsset = function shouldIncludeAsset(assetIdToFind) {
  return function (asset) {
    var assetId = asset.assetId;
    return assetId === assetIdToFind;
  };
};

function mergeAssets(assetsMap, assets, organisationId) {
  var newAssets = assets ? assets.slice() : [];
  assetsMap.forEach(function (asset, assetId) {
    if (!asset) {
      return;
    }

    if (asset.organisationId === organisationId && !newAssets.some(shouldIncludeAsset(assetId))) {
      var newAsset = _objectSpread({}, asset, {
        permissions: DEFAULT_INITIAL_PERMISSIONS
      });

      newAssets.unshift(newAsset);
      return;
    }

    var index = (0, _findIndex.default)(newAssets, assetId);

    if (!newAssets[index]) {
      return;
    }

    if (newAssets[index].organisationId !== organisationId) {
      newAssets.splice(index, 1);
      return;
    }

    if (newAssets[index].status !== asset.status && asset.status === 'UPLOADED') {
      newAssets.splice(index, 1, asset);
    }
  });
  return newAssets;
}

var _default = mergeAssets;
exports.default = _default;